import { gql } from "apollo-boost"

export const GET_DASHBOARD = gql`
query Dashboard($where: dashboardWhereInput!) {
  dashboard(where: $where) {
    totalMoney
    cashPercent
    totalPrice
    sumPrice
    transferPercent
    sumPriceBaht
    sumPriceUsd 
    goodProduct {
      amount
      name
    } 
  }
  }
`

export const GET_REPORT_INCOME_COST = gql`
query Dashboard($where: dashboardWhereInput!) {
  dashboard(where: $where) {
    originPriceLak
    originPriceBaht
    originPriceUsd
    totalPriceLak
    totalPriceBaht
    totalPriceUsd
  }
}
`

export const GET_REPORT_INCOME_COST_V2 = gql`
query ReportCostProfit($where: dashboardWhereInput!) {
  ReportCostProfit(where: $where) {
    datas
  }
}
`
export const GET_REPORT_ORDERS_STAFF = gql`
query ReportStaffs($where: dashboardWhereInput!, $limit: Int, $skip: Int) {
  ReportStaffs(where: $where, limit: $limit, skip: $skip) {
    total
    reports {
      totalSalesKip
      totalProfitKip
      balanceKip
      totalSalesBaht
      totalProfitBaht
      balanceBaht
      totalSalesUsd
      totalProfitUsd
      balanceUsd
      totalStockValue
    }
    datas {
      amount
      code
      id
      createdAt
      currency
      customerId
      customerLastName
      customerName
      district
      isPaymented
      note
      orders {
        id
        totalPriceUsd
        totalPriceBaht
        totalPrice
        status
        productName
        price
        originPrice
        currency
        amount
      }
      phone
      province
      receivedMoney
      staff
      staffLastname
      sumPrice
      sumPriceBaht
      sumPriceUsd
      totalPrice
      type
      village
    }
  }
}
`;

export const GET_REPORT_DIARY_COST_PROFIT = gql`
query ReportDailyCostProfit($where: dashboardWhereInput!) {
  ReportDailyCostProfit(where: $where) {
    datas {
      date
      sale {
        price
        priceBaht
        priceUsd
      }
      cost {
        price
        priceBaht
        priceUsd
      }
      totalDiscount
    }
  }
}
`

export const GET_REPORT_ORDERS_STAFF_V2 = gql`
  query ReportStaffsV2($where: dashboardWhereInput!, $limit: Int, $skip: Int) {
    ReportStaffsV2(where: $where, limit: $limit, skip: $skip) {
      total
      status
      msg
      err
      reports {
        totalSalesKip
        totalProfitKip
        balanceKip
        totalSalesBaht
        totalProfitBaht
        balanceBaht
        totalSalesUsd
        totalProfitUsd
        balanceUsd
        totalStockValue
        balanceSumPrice
        totalTransfer
        totalCash
      }
      datas {
        amount
        code
        id
        createdAt
        currency
        customerId
        customerLastName
        customerName
        district
        isPaymented
        note
        orders {
          id
          totalPriceUsd
          totalPriceBaht
          totalPrice
          status
          productName
          price
          originPrice
          currency
          amount
          stock {
            name
          }
        }
        phone
        province
        receivedMoney
        staff
        staffLastname
        sumPrice
        sumPriceBaht
        sumPriceUsd
        totalPrice
        type
        village
      }
    }
  }
`;

export const GET_REPORT_CUSTOMER_ORDERS = gql`
  query ReportCustomerOrders($where: ReportCustomerOrderWhereInput, $skip: Int, $limit: Int) {
    reportCustomerOrders(where: $where, skip: $skip, limit: $limit) {
      total
      data {
        customerId
        customerName
        customerLastName
        phone
        totalOrders
      }
    }
  }
`


export const GET_REPORT_CATEGORY_V2 = gql`
  query ReportOrderCategoryV2($where: ReportWhereInput!) {
    reportOrderCategoryV2(where: $where) {
      total
      data {
        _id {
          _id
          category
          currency
        }
        count
        price
        originPrice
        totalPrice
        totalPriceBaht
        totalPriceUsd
        originSumPrice
        totalDiscount
      }
      status
      msg
    }
  }
`
export const GET_REPORT_CATEGORY = gql`
query ReportOrderCategory($where: ReportWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  reportOrderCategory(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      totalPriceUsd
      totalPriceBaht
      totalPrice
      originSumPrice
      count
      _id
    }
  }
}
`

export const GET_REPORT_STOCK = gql`
  query ReportStock($where: ReportWhereInput!) {
    reportStock(where: $where) {
      listTotal
      listAmount
      listPrice
      saleTotal
      saleAmount
      salePrice
      amountFreeTotal
      amountFreeAmount
      amountFreePrice
    }
  }
`;


export const GET_REPORT_PRODUCT = gql`
query ReportProductOrder($where: ReportWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  reportProductOrder(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    sumBahtPrice
    sumPrice
    sumUSDPrice
    data {
      productName
      amount
      currency
      price
      totalPrice
    }
  }
}
`

export const GET_PRODUCT_SALE_OUT = gql`
query ProductSaleOut($limit: Int, $skip: Int, $orderBy: OrderByInput, $where: ProductWhereInput) {
  productSaleOut(limit: $limit, skip: $skip, orderBy: $orderBy, where: $where) {
    data {
      name
      barCode
      amount
      price
      category {
        id
        name
      }
      brand {
        id
        name
      }
      unitId {
        id
        name
      }
      currency
    }
    total
  }
}
`

export const GET_NOTIFICATION_PRODUCT = gql`
query ReportNoticProduct($where: ProductWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  reportNoticProduct(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      name
      amount
      barCode
      price
      category {
        id
        name
      }
      unitId {
        id
        name
      }
      brand {
        id
        name
      }
      image
    }
  }
}
`

export const reportJackSportFabricFinanceDetail =  gql`
query ReportJacksportFabricFinanceDetailed($where: ReportWhereInput!) {
  reportJacksportFabricFinanceDetailed(where: $where) {
    totalBoughtAmount
    totalBoughtExpense
    totalSoldAmount
    totalSoldFreeAmount
    totalSoldIncome
    totalSoldCost
    totalGrossProfit
    details {
      fabricId
      fabricName
      boughtAmount
      boughtExpense
      soldAmount
      soldFreeAmount
      soldIncome
      soldCost
      grossProfit
      currentTotalQty
    }
  }
}
`